import React from 'react';
import Layout from 'components/layouts';
import Title from 'components/typografy/title';
import styles from './styles.module.scss';
import Main from './main';
import Info from './info';
import Tabs from './tabs';
import Card from './card';

const ProfilePage: React.FC = () => {

  return (
    <Layout>
      <div className={styles.wrapper}>
        <div className={styles.top}>
          <Title variant={'h1'}>My Profile</Title>
        </div>
        <Card>
          <Main />
          <Info />
        </Card>
        <Tabs />
      </div>
    </Layout>
  );
};

export default ProfilePage;
